import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import WhatIsSection from './components/WhatIsSection';
import FeaturesGrid from './components/FeaturesGrid';
import ComparisonTable from './components/ComparisonTable';
import WhyChooseSection from './components/WhyChooseSection';
import CategoryGrid from './components/CategoryGrid';
import BlogArticles from './components/BlogArticles';
import SecuritySection from './components/SecuritySection';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';

const homepageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Vigorbuy Spreadsheet - Complete Guide & Resources',
  description: 'Discover Vigorbuy Spreadsheet: complete guides, expert reviews, professional templates, and comprehensive resources for smarter spreadsheet management.',
  url: 'https://vigorbuyspread.pics/',
  mainEntity: {
    '@type': 'Organization',
    name: 'Vigorbuy Spreadsheet',
    url: 'https://vigorbuyspread.pics/',
    logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/a9b8fc4c2048f16265644a3fc912425a.jpeg',
  },
};

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: [
    {
      '@type': 'Question',
      name: 'What is Vigorbuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Vigorbuy Spreadsheet is a powerful spreadsheet platform designed for business management, financial tracking, inventory control, and data organization. It combines an intuitive interface with advanced features like automated calculations, customizable templates, real-time collaboration, and seamless cloud synchronization.',
      },
    },
    {
      '@type': 'Question',
      name: 'Is Vigorbuy Spreadsheet safe to use?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Yes, Vigorbuy Spreadsheet is built with security in mind. The platform employs data encryption, secure access controls, and privacy protections to keep your information safe. We recommend using strong passwords, enabling two-factor authentication, and regularly backing up important files.',
      },
    },
    {
      '@type': 'Question',
      name: 'How does Vigorbuy Spreadsheet work?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Vigorbuy Spreadsheet works similarly to traditional spreadsheet applications but with enhanced business-focused features. You create or open spreadsheets in your browser, organize data, apply formulas for calculations, create charts, and share files for real-time collaboration.',
      },
    },
    {
      '@type': 'Question',
      name: 'What are the best Vigorbuy Spreadsheet templates?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Popular templates include the Business Budget Template, Inventory Management Template, Sales Dashboard Template, Project Timeline Template, and Expense Report Template. Each comes pre-formatted with formulas and can be customized to match your workflow.',
      },
    },
    {
      '@type': 'Question',
      name: 'Can Vigorbuy Spreadsheet replace Excel or Google Sheets?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Vigorbuy Spreadsheet offers unique advantages for business users with specialized templates and business-focused features. It serves as a strong complement or alternative to traditional spreadsheet tools depending on your specific business needs.',
      },
    },
    {
      '@type': 'Question',
      name: 'How do I get started with Vigorbuy Spreadsheet?',
      acceptedAnswer: {
        '@type': 'Answer',
        text: 'Visit the official Vigorbuy Spreadsheet website at kaspreadsheet.com, create your account, and explore the template library. Start with a pre-built template for your specific use case, then customize it as you become more familiar with the platform.',
      },
    },
  ],
};

export default function Home() {
  return (
    <>
      <title>Vigorbuy Spreadsheet 2026: Complete Guide, Features &amp; Resources</title>
      <meta name="description" content="Discover Vigorbuy Spreadsheet: complete guides, expert reviews, professional templates, and comprehensive resources for smarter spreadsheet management. Explore features, comparisons, and best practices for business productivity." />
      <meta name="keywords" content="vigorbuy spreadsheet, vigorbuy spreadsheet guide, vigorbuy spreadsheet review, spreadsheet templates, spreadsheet resources, business spreadsheet" />
      <link rel="canonical" href="https://vigorbuyspread.pics/" />
      <meta name="robots" content="index, follow" />
      <meta property="og:title" content="Vigorbuy Spreadsheet 2026: Complete Guide, Features &amp; Resources" />
      <meta property="og:description" content="Discover Vigorbuy Spreadsheet: complete guides, expert reviews, professional templates, and comprehensive resources for smarter spreadsheet management." />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://vigorbuyspread.pics/" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Vigorbuy Spreadsheet 2026: Complete Guide, Features &amp; Resources" />
      <meta name="twitter:description" content="Discover Vigorbuy Spreadsheet: complete guides, expert reviews, professional templates, and comprehensive resources for smarter spreadsheet management." />

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(homepageSchema) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />

      <Navbar />

      <main>
        <HeroSection />
        <TrustBar />
        <WhatIsSection />
        <FeaturesGrid />
        <ComparisonTable />
        <CategoryGrid />
        <WhyChooseSection />
        <BlogArticles />
        <SecuritySection />
        <FAQSection />
        <FinalCTA />
      </main>

      <Footer />
    </>
  );
}